export interface SupplierAddressEdit {
  id: string;
  supplierId: string;
  addressId: string;
}
